"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        label: {
            textTransform: 'uppercase',
            color: function (_a) {
                var headerHighLight = _a.headerHighLight;
                return headerHighLight ? theme.palette.primary.main : theme.palette.grey[500];
            },
            fontWeight: function (_a) {
                var headerHighLight = _a.headerHighLight;
                return (headerHighLight ? 'bold' : 'normal');
            },
        },
        errorMessage: {
            fontWeight: 700,
        },
    });
});
